<template>
  <v-layout
    column
    fill-height
    class="mb-3"
  >
    <v-card-title class="mb-0 pb-0" v-if="showButtons">
      <v-btn icon :to="{ name: routeName.USER }" active-class="">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="can('edit users')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             icon
             v-bind="attrs"
             v-on="on"
             @click="editUser"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EDIT') }}</span>
      </v-tooltip>
      <div>
        <v-tooltip bottom v-if="currentUser.user.id != user.id">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="deleteUser">
              <v-icon>block</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DELETE') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-title class="mt-1 pt-0">
    </v-card-title>
    <v-tabs
      :value="value"
      @change="tabChanged"
      centered
      grow
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab dark href="#user">
          {{ $t('USER') }}
        </v-tab>
        <v-tab dark href="#group">
          {{ $t('GROUPS') }}
        </v-tab>
        <v-tab dark href="#permission">
          {{ $t('PERMISSIONS') }}
        </v-tab>
    </v-tabs>
  </v-layout>
</template>
<script>

  import { mapGetters } from 'vuex';

  export default {
    name: 'UserTabs',
    props: {
      user: Object,
      value: String,
      showButtons: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
    },
    methods: {
      deleteUser() {
        this.$emit('delete');
      },

      editUser() {
        this.$emit('edit');
      },

      tabChanged(tab) {
        this.$emit('input', tab);
      },

    },
  };
</script>
